import { createPortal } from 'react-dom'
import { useLang } from '../i18n'
import { useUpdateReady } from '../lib/desktop'

/**
 * "An update is ready — Restart" banner for Niobe Desktop. Absent in a browser (there is no
 * `window.niobeDesktop.updates` to read). Never steals focus — unlike the error popup, this must
 * not interrupt work in progress, so it just sits there until the member clicks Restart (or the
 * desktop app's own silent idle auto-apply eventually fires on its own). Rendered once at the app
 * root, outside `<App/>`, so it shows on every view.
 */
export function UpdateReadyBanner() {
  const { t } = useLang()
  const { channel, state, restarting, restart } = useUpdateReady()
  if (!channel) return null

  const message =
    channel === 'spa'
      ? t('update_ready_spa')
      : t('update_ready_app').replace('{n}', state?.appVersion ?? '')

  return createPortal(
    <div className="update-banner" role="status" aria-live="polite">
      <span>{message}</span>
      <button type="button" disabled={restarting} onClick={restart}>
        {restarting ? t('update_restarting') : t('update_restart')}
      </button>
    </div>,
    document.body,
  )
}
